import * as wjcCore from '@mescius/wijmo';
// angular
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpHeaders} from '@angular/common/http';

// libs
import {Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

// module
import {AuthService} from '../services/auth.service';
import * as authAction from '../actions/auth.action';
import {ConfigService} from '../services/config.service';

// jQuery.param 相当 (application/x-www-form-urlencoded)
function formParam(obj: Record<string, string>): string {
  const params = new URLSearchParams();
  Object.keys(obj).forEach(key => params.set(key, obj[key]));
  return params.toString();
}

@Injectable()
export class AuthEffects {
  redirectUri = '';

  login$ = createEffect(() => this.actions$.pipe(
    ofType(authAction.ActionTypes.LOGIN_USER),
    map((action: authAction.LoginUserAction) => action.payload),
    switchMap(payload => {
      const data = formParam({grant_type: 'password', username: payload.username, password: payload.password});
      this.config.setTokenPrefix(payload.tokenPrefix);
      return this.auth.login(data, payload.url, {headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')}).pipe(
        map(() => {
          this.router.navigateByUrl(this.redirectUri);
          return new authAction.LoginSuccessAction();
        }),
        catchError((error: unknown) => {
          this.store.dispatch(new authAction.LoginFailureAction());
          return of(error);
        }),
      );
    })), {dispatch: false});

  logout$ = createEffect(() => this.actions$.pipe(
    ofType(authAction.ActionTypes.SIGNOUT_USER),
    map((action: authAction.SignoutUserAction) => {
      this.auth.logout().pipe(
        catchError((error: unknown) => {
          this.store.dispatch(new authAction.SignoutFailureAction());
          return of(error);
        }),
      ).subscribe();
      if (wjcCore.isString(action.payload.url)) {
        this.router.navigateByUrl(action.payload.url);
      } else {
        this.router.navigateByUrl(this.config.options.loginPage);
      }
      return new authAction.SignoutSuccessAction();
    })));

  constructor(private config: ConfigService,
              private store: Store<any>,
              private router: Router,
              private actions$: Actions,
              private auth: AuthService) {
    this.store.select<any>('authFeature' as any).subscribe((state: any) => {
      if (wjcCore.isObject(state?.auth) && wjcCore.isString(state.auth.redirectUri)) {
        this.redirectUri = state.auth.redirectUri;
      }
    });
  }
}
